import { ReactNode, useState } from 'react';

const SPKTabs = ({
  tabs,
}: {
  tabs: { title: string; children: ReactNode }[];
}) => {
  const [activeTab, setActiveTab] = useState(0);
  return (
    <div>
      <div className="flex flex-row justify-between text-sm rounded-t-xl overflow-hidden border-b-2">
        {tabs.map(({ title }, index) => {
          return (
            <div
              role="button"
              key={`tab_${title}`}
              className={`w-full p-4 ${
                activeTab === index
                  ? 'bg-white font-bold'
                  : 'bg-employer-background/50 font-light'
              }`}
              onClick={() => setActiveTab(index)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  setActiveTab(index);
                }
              }}
              tabIndex={0}
            >
              {title}
            </div>
          );
        })}
      </div>
      {tabs.map(({ children }, index) => {
        return (
          <div
            key={`${Math.random()}`}
            className={`${activeTab === index ? 'flex' : 'hidden'} mt-4`}
          >
            {children}
          </div>
        );
      })}
    </div>
  );
};

export default SPKTabs;
